__turbopack_context__.v({
  "ariaSlider": "PlasmicSlider-module__vcAbfW__ariaSlider",
  "ariaSliderOutput": "PlasmicSlider-module__vcAbfW__ariaSliderOutput",
  "ariaSliderTrack": "PlasmicSlider-module__vcAbfW__ariaSliderTrack",
  "background": "PlasmicSlider-module__vcAbfW__background",
  "description": "PlasmicSlider-module__vcAbfW__description",
  "foreground": "PlasmicSlider-module__vcAbfW__foreground",
  "freeBox__s58To": "PlasmicSlider-module__vcAbfW__freeBox__s58To",
  "freeBox__t42MY": "PlasmicSlider-module__vcAbfW__freeBox__t42MY",
  "sliderThumb__g0Ux2": "PlasmicSlider-module__vcAbfW__sliderThumb__g0Ux2",
  "slotTargetLabel": "PlasmicSlider-module__vcAbfW__slotTargetLabel",
  "text": "PlasmicSlider-module__vcAbfW__text",
  "text__y2WZ": "PlasmicSlider-module__vcAbfW__text__y2WZ",
});
